var React = require('react');

function IconCheckmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.81353 7.88963L0.968732 4.78001L0 5.83147L3.81353 10L12 1.05145L11.0381 0L3.81353 7.88963Z"}));
}

IconCheckmark.defaultProps = {"viewBox":"0 0 12 10","fill":"none"};

module.exports = IconCheckmark;

IconCheckmark.default = IconCheckmark;
